// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ViewTableExtended } from '../../../assets/icons/extended/entities/view-table.svg?react';
import { createIcons } from '../../Icon';
const ViewTableIcon = /* @__PURE__ */ createIcons('ViewTable', {
    extended: ViewTableExtended
});
ViewTableIcon.supportedTypes = ['extended'];
ViewTableIcon.category = 'entities';
export default ViewTableIcon;
